import { App } from 'vue';
import type { SFCWithInstall } from '@/types/utils';
import PageCard from './package/index.vue';

PageCard.install = (app: App): void => {
  app.component(PageCard.name, PageCard);
};

export default PageCard as SFCWithInstall<typeof PageCard>;
